export default {
	'production-board': {
		id: 'production-board',
		label: '生产看板',
		code: '0010_0007'
	}
}
